import { ApiState, Action } from '../../types';
import { serviceReducer, callService } from '../../shared/hooks/serviceReducer';
import {
  GrievanceFilter,
  GrievanceList,
  QueryGroup,
  QuerySubGroup,
} from '../../services/types/Grievance';

export type GrievanceAction =
  | Action<GrievanceList, GrievanceFilter>
  | {
      type: 'QUERY_GROUP';
      value: QueryGroup;
    }
  | {
      type: 'QUERY_SUB_GROUP';
      value: QuerySubGroup;
    }
  | { type: 'PAGE'; value: number }
  | { type: 'PAGE_SIZE'; value: number }
  | { type: 'ORDER'; column: string; descending: boolean }
  | { type: 'YEAR'; value: number };

const reducer = (
  state: ApiState<GrievanceList, GrievanceFilter>,
  action: GrievanceAction
): ApiState<GrievanceList, GrievanceFilter> => {
  switch (action.type) {
    case 'QUERY_GROUP': {
      const filter = {
        ...state.filter,
        queryGroup: action.value,
        querySubGroup: QuerySubGroup.All,
        pageNumber: 1,
        year: undefined,
      };
      return callService(state, filter);
    }
    case 'QUERY_SUB_GROUP': {
      const filter = {
        ...state.filter,
        querySubGroup: action.value,
        pageNumber: 1,
        year: undefined,
      };
      return callService(state, filter);
    }
    case 'YEAR': {
      const filter = { ...state.filter, year: action.value, pageNumber: 1 };
      return callService(state, filter);
    }
    case 'PAGE':
      return callService(state, { pageNumber: action.value });
    case 'PAGE_SIZE':
      return callService(state, { pageSize: action.value });
    case 'ORDER':
      return callService(state, { sortField: action.column, sortDescending: action.descending });
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
